import type { MusicService } from '../types';
import { ImporterID, MusicAPIIntegrationID } from '../ids';
import { musicServiceMessages } from '../messages';

export const jiosaavn: MusicService = {
  id: 'jiosaavn',
  name: 'JioSaavn',
  shortName: 'JioSaavn',
  isSupported: true,
  isComingSoon: false,
  areStatsSupported: false,
  areStatsComingSoon: false,
  isAlbumTransferSupported: false,
  color: {
    primary: '#2bc5b4',
    label: '#20B4A3',
    background: '#6f817f',
  },
  importerID: ImporterID.JioSaavn,
  musicAPIID: MusicAPIIntegrationID.JioSaavn,
  linkType: 'jiosaavn',
  assets: {
    logo: { light: 'jiosaavn-light.svg', dark: 'jiosaavn-dark.svg' },
    logoPadding: { light: 'jiosaavn-light-padding.svg', dark: 'jiosaavn-dark-padding.svg' },
    logoColor: { light: 'jiosaavn-color-light.svg', dark: 'jiosaavn-color-dark.svg' },
    logoColorPadding: {
      light: 'jiosaavn-color-light-padding.svg',
      dark: 'jiosaavn-color-dark-padding.svg',
    },
    logoOnBackground: 'jiosaavn-color-dark.svg',
  },
  whatIsDescription: musicServiceMessages.jiosaavnWhatIs,
};
